export const baseJsonLdCountry = {
  BA: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-trgovina gdje možete pronaći sve vrste materijala za dostavljače, kao i ekološke i biorazgradive ambalaže.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/BA/bs/pocetak',
      description: 'Dobrodošli u __BRAND_NAME__: torbe, održive ambalaže, escajg, materijali za dostavljače i mnogo više.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/BA/bs/pocetak#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'BA',
        availableLanguage: ['Bosnian'],
      },
    },
  ],
  BG: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Електронен магазин, където можете да намерите всички видове материали за куриери, както и екологични и биоразградими опаковки.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/BG/bg/nachalo',
      description:
        'Добре дошли в __BRAND_NAME__: чанти, устойчиви опаковки, прибори за хранене, материали за куриери и много друго.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/BG/bg/nachalo#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'BG',
        availableLanguage: ['Bulgarian'],
      },
    },
  ],
  CI: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Commerce électronique où vous trouverez toutes sortes de matériaux pour les coursiers, ainsi que des emballages écologiques et biodégradables.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/CI/fr/debut',
      description:
        'Bienvenue à __BRAND_NAME__ : sacs, emballages durables, couverts, matériel pour coursiers et bien plus encore.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/CI/fr/debut#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'CI',
        availableLanguage: ['French'],
      },
    },
  ],
  ES: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Ecommerce donde encontrarás todo tipo de material para repartidores, así como envases ecológicos y biodegradables.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/ES/es/inicio',
      description:
        'Bienvenido a __BRAND_NAME__: bolsas, envases sostenibles, cubertería, material para repartidores y mucho más.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/ES/es/inicio#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'ES',
        availableLanguage: ['Spanish'],
      },
    },
  ],
  GE: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'ელექტრონული კომერცია, სადაც ნახავთ კურიერებისთვის ყველა სახის მასალებს, ასევე ეკოლოგიური და ბიოდეგრადაბლური შეფუთვების.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/GE/ka/dacqeba',
      description:
        'კეთილი მოსახლეობა __BRAND_NAME__-ში: ჩანთები, გარგებითი შეფუთვები, საჭმელის საჭირო ნივთები, კურიერების მასალები და სხვა ბევრი.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/GE/ka/dacqeba#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'GE',
        availableLanguage: ['Georgian'],
      },
    },
  ],
  HR: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-trgovina u kojoj možete pronaći sve vrste materijala za dostavljače, kao i ekološka i biorazgradiva pakiranja.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/HR/hr/pocetak',
      description:
        'Dobrodošli u __BRAND_NAME__: torbe, održiva pakiranja, pribor za jelo, materijali za dostavljače i mnogo više.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/HR/hr/pocetak#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'HR',
        availableLanguage: ['Croatian'],
      },
    },
  ],
  IT: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-commerce dove troverai tutti i tipi di materiali per corrieri, così come contenitori ecologici e biodegradabili.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/IT/it/inizio',
      description:
        'Benvenuto a __BRAND_NAME__: borse, contenitori sostenibili, posate, materiale per corrieri e molto altro.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/IT/it/inizio#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'IT',
        availableLanguage: ['Italian'],
      },
    },
  ],
  KG: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Электронная коммерция, где вы найдете все виды материалов для курьеров, а также экологичные и биоразлагаемые упаковки.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/KG/ru/glavnaia',
      description:
        'Добро пожаловать в __BRAND_NAME__: сумки, устойчивые упаковки, столовые приборы, материалы для курьеров и многое другое.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/KG/ru/glavnaia#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'KG',
        availableLanguage: ['Russian'],
      },
    },
  ],
  KZ: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Электронная коммерция, где вы найдете все виды материалов для курьеров, а также экологичные и биоразлагаемые упаковки.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/KZ/ru/glavnaia',
      description:
        'Добро пожаловать в __BRAND_NAME__: сумки, устойчивые упаковки, столовые приборы, материалы для курьеров и многое другое.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/KZ/ru/glavnaia#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'KZ',
        availableLanguage: ['Russian'],
      },
    },
  ],
  MA: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Commerce électronique où vous trouverez toutes sortes de matériaux pour les coursiers, ainsi que des emballages écologiques et biodégradables.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/MA/fr/debut',
      description:
        'Bienvenue à __BRAND_NAME__ : sacs, emballages durables, couverts, matériel pour coursiers et bien plus encore.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/MA/fr/debut#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'MA',
        availableLanguage: ['French'],
      },
    },
  ],
  MD: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'Comerț electronic unde veți găsi toate tipurile de materiale pentru curieri, precum și ambalaje ecologice și biodegradabile.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/MD/ro/inceput',
      description:
        'Bine ai venit la __BRAND_NAME__: genți, ambalaje sustenabile, tacâmuri, materiale pentru curieri și mult mai mult.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/MD/ro/inceput#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'MD',
        availableLanguage: ['Romanian'],
      },
    },
  ],
  ME: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-trgovina gdje možete pronaći sve vrste materijala za dostavljače, kao i ekološke i biorazgradive ambalaže.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/ME/cnr/pocni',
      description: 'Dobrodošli u __BRAND_NAME__: torbe, održive ambalaže, escajg, materijali za dostavljače i mnogo više.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/ME/cnr/pocni#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'ME',
        availableLanguage: ['Montenegrin'],
      },
    },
  ],
  PL: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-commerce, gdzie znajdziesz wszystkie rodzaje materiałów dla kurierów, a także ekologiczne i biodegradowalne opakowania.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/PL/pl/glowna',
      description:
        'Witaj w __BRAND_NAME__: torby, zrównoważone opakowania, sztućce, materiały dla kurierów i wiele więcej.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/PL/pl/glowna#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'PL',
        availableLanguage: ['Polish'],
      },
    },
  ],
  PT: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-commerce onde você encontrará todos os tipos de materiais para entregadores, bem como embalagens ecológicas e biodegradáveis.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/PT/pt/comeco',
      description:
        'Bem-vindo à __BRAND_NAME__: sacolas, embalagens sustentáveis, talheres, material para entregadores e muito mais.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/PT/pt/comeco#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'PT',
        availableLanguage: ['Portuguese'],
      },
    },
  ],
  RO: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-commerce unde vei găsi toate tipurile de materiale pentru curieri, precum și ambalaje ecologice și biodegradabile.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/RO/ro/inceput',
      description:
        'Bine ai venit la __BRAND_NAME__: genți, ambalaje sustenabile, tacâmuri, materiale pentru curieri și mult mai mult.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/RO/ro/inceput#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'RO',
        availableLanguage: ['Romanian'],
      },
    },
  ],
  RS: [
    {
      '@type': 'WebSite',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      description:
        'E-trgovina gde možete pronaći sve vrste materijala za dostavljače, kao i ekološke i biorazgradive ambalaže.',
    },
    {
      '@type': 'WebPage',
      name: 'Home __BRAND_NAME__',
      url: '__BASE_URL__/RS/sr/pocni',
      description: 'Dobrodošli u __BRAND_NAME__: torbe, održive ambalaže, escajg, materijali za dostavljače i mnogo više.',
      potentialAction: {
        '@type': 'SearchAction',
        target: '__BASE_URL__/RS/sr/pocni#/dfclassic/query={search_term_string}&query_name=match_and',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '__BRAND_NAME__',
      url: '__BASE_URL__/',
      logo: '__BRAND_LOGO__',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'RS',
        availableLanguage: ['Serbian'],
      },
    },
  ],
};
